<ng-container *ngIf="orderStatusDisplay">
  <a *ngIf="shipOrderError" (click)="showShipOrderError()">
    <i
      class="fa fa-exclamation-circle cell-address-red mr-2 icon-address-medium"
    ></i>
  </a>
  <mat-chip class="lum-chip lum-chip--small lum-noclick" disableRipple>
    <mat-icon class="ag-status-circle {{ colorClass }} mr-2"></mat-icon>
    {{ orderStatusDisplay | capitalize: true }}
  </mat-chip>
</ng-container>
